/**
 * 接口白名单 企业客服和在线客服的区分，针对在线工作台及在线工作台首页页面
 * 再次白名单中的接口须带workbench参数
 */
export default [
  '/crm-online-service-app/onlineCustomerService/conversationManage/sendInviteComments', // 发送邀评
  '/crm-access/onlineCustomerService/conversationManage/finishConversa', // 结束会话
  '/crm-online-service-app/onlineCustomerService/conversationManage/conversationRecordByPage', // 获取历史聊天会话
  '/crm-online-service-app/onlineCustomerService/order/tempOrdersMessage', // 获取会话内容
  '/crm-online-service-app/onlineCustomerService/conversationManage/clearFirstUnReadMsg', // 清除当前会话在会话列表中的未回复时长
  '/crm-online-service-app/onlineCustomerService/conversationManage/getConversationTitleInfo', // 获取等待时长、会话时长、对话次数
  '/crm-online-service-app/onlineCustomerService/serviceUser/queryQueueSize', // 查询排队队列长度
  '/crm-online-service-app/onlineCustomerService/conversationManage/onlineConversation', // 查询客服当前会话列表
  '/crm-online-service-app/myCommonSentence/query', // 常用语查询
  '/crm-online-service-app/myCommonSentence/add', // 添加常用语
  '/crm-online-service-app/myCommonSentence/del', // 删除常用语
  '/crm-online-service-app/onlineCustomerService/team/queryOnlineTeamCategory', // 查询可转接的技能组， 注意：（这个接口企业报表写死企业客服的workbenchid，并传notWithWorkBenchId）
  '/crm-online-service-app/onlineCustomerService/conversationManage/accessConversation', // 手动接入
  '/crm-online-service-app/onlineCustomerService/conversationManage/historyConversation', // 从历史会话接入
  '/crm-online-service-app/onlineCustomerService/serviceUser/changeStatus', // 修改状态
  '/crm-online-service-app/onlineCustomerService/serviceUser/getOnlineWorkbenchInfo', // 获取在线工作台的配置信息
  '/crm-online-service-app/onlineCustomerService/conversationMessage/sendMessage', // 发送消息
  '/crm-online-service-app/onlineCustomerService/conversationMessage/currentServiceMessagesByPage', // 历史消息聊天窗口分页消息
  '/crm-online-service-app/onlineCustomerService/setting/getReplyList', // 常用语搜索获取快捷回复语
  '/crm-online-service-app/newImMessage/read/doOcsRead', // 修改消息读取状态
  '/crm-online-service-app/newImMessage/receive/ocsReceiveMessage', // 接收新消息
  '/crm-online-service-app/onlineCustomerService/conversationManage/historyConversationByPage', // 搜索历史会话列表
  '/crm-online-service-app/onlineCustomerService/team/queryOnlineMemberByNameOrNo', // 远程查询转接人
  '/crm-online-service-app/onlineCustomerService/serviceUser/queryStatus', // 获取状态
  '/crm-online-service-app/onlineCustomerService/conversationManage/createSession', // 主动发起会话
  '/crm-online-service-app/onlineCustomerService/setting/personStatistics', //在线客服- 首页 用户信息 统计数据
  '/crm-online-service-app/onlineCustomerService/conversationManage/getIncrementInfo', // 轮训拉取会话列表增量消息（新会话、新消息摘要、新消息数量）
  '/crm-online-service-app/onlineCustomerService/conversationManage/getCurrentOnGoingConversation' // 长连通知的新消息  用户不在当前列表中 需要获取新建的会话
]
